import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import Layout from '../components/Layout.jsx';
import { api, getUser } from '../api.js';

const TIPOS = [
  { value: 'habitacion', label: 'Habitación' },
  { value: 'oficina', label: 'Oficina' },
  { value: 'bodega', label: 'Bodega' },
  { value: 'otro', label: 'Otro' },
];

export default function AdminUnidades() {
  const me = getUser();
  if (me?.rol !== 'admin') return <Navigate to="/" replace />;

  const [unidades, setUnidades] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ codigo: '', nombre: '', tipo: 'habitacion' });
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState('');

  const cargar = async () => {
    const r = await api.unidades();
    setUnidades(r.unidades);
  };
  useEffect(() => { cargar(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMsg('');
    try {
      await api.crearUnidad(form);
      setForm({ codigo: '', nombre: '', tipo: 'habitacion' });
      setShowForm(false);
      await cargar();
    } catch (err) {
      setMsg('Error: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  const tipoLabel = (t) => TIPOS.find((x) => x.value === t)?.label ?? t;

  return (
    <Layout>
      <div className="mb-8 flex items-end justify-between">
        <div>
          <div className="font-mono text-[10px] uppercase tracking-[0.18em] text-muted mb-2">Administración</div>
          <h1 className="text-4xl font-bold tracking-tight">Unidades</h1>
          <p className="text-muted mt-2">Habitaciones, oficinas o cualquier espacio físico que tenga inventario propio.</p>
        </div>
        <button onClick={() => setShowForm((s) => !s)} className="btn-primary">
          {showForm ? 'Cancelar' : '+ Nueva unidad'}
        </button>
      </div>

      {showForm && (
        <form onSubmit={submit} className="card mb-6 grid grid-cols-1 md:grid-cols-4 gap-4">
          <div>
            <label className="label">Código</label>
            <input className="input font-mono" value={form.codigo} onChange={(e) => setForm({ ...form, codigo: e.target.value })} placeholder="H01" required />
          </div>
          <div className="md:col-span-2">
            <label className="label">Nombre</label>
            <input className="input" value={form.nombre} onChange={(e) => setForm({ ...form, nombre: e.target.value })} placeholder="Habitación 01" />
          </div>
          <div>
            <label className="label">Tipo</label>
            <select className="input" value={form.tipo} onChange={(e) => setForm({ ...form, tipo: e.target.value })}>
              {TIPOS.map((t) => (
                <option key={t.value} value={t.value}>{t.label}</option>
              ))}
            </select>
          </div>
          {msg && <div className="md:col-span-4 text-sm text-red-700 font-mono">{msg}</div>}
          <div className="md:col-span-4">
            <button className="btn-accent" disabled={loading}>{loading ? 'Guardando…' : 'Crear unidad'}</button>
          </div>
        </form>
      )}

      <div className="card overflow-x-auto">
        <table className="w-full min-w-[480px]">
          <thead>
            <tr className="text-left">
              <th className="label pb-3">Código</th>
              <th className="label pb-3">Nombre</th>
              <th className="label pb-3">Tipo</th>
              <th className="label pb-3 text-right">Estado</th>
            </tr>
          </thead>
          <tbody>
            {unidades.map((u) => (
              <tr key={u.id} className="border-t border-line">
                <td className="py-3 font-mono text-sm">{u.codigo}</td>
                <td className="py-3 font-medium tracking-tight">{u.nombre ?? '—'}</td>
                <td className="py-3 font-mono text-xs uppercase tracking-[0.14em] text-muted">{tipoLabel(u.tipo)}</td>
                <td className="py-3 text-right">
                  <span className={`pill ${u.activo ? 'bg-lime/30' : 'bg-bone'}`}>{u.activo ? 'Activa' : 'Inactiva'}</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Layout>
  );
}
